import React from 'react';

import styled from '@emotion/styled';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useParsedCohortQueryParam } from 'components/hooks/useParsedCohortQueryParam';
import { GoalAnalyticsProvider } from 'screens/analytics/goals/GoalAnalyticsContext';
import { themeColors } from 'themes/clients/baseTheme';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ArchivedGoals } from './Archived';
import TabbedHeader from './Header';
import { useGoalsRouteMatch } from './hooks/useGoalsRouteMatch';

function TeamWithoutGoalAnalyticsProvider() {
  /*  read keyResultsName and objectivesName from new config */
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const { isArchivedRoute } = useGoalsRouteMatch();

  const modifyGoalsString = (str) => {
    if (str === '') {
      return modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE);
    }
    if (str === `My Goals`) {
      return `My ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)}`;
    }
    return `${str}'s ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)}`;
  };

  const { name: teamName } = useParsedCohortQueryParam() ?? {};
  const modifiedTeamName = teamName ? modifyGoalsString(teamName) : null;

  if (isArchivedRoute) {
    return <ArchivedGoals />;
  }

  return <TabbedHeader teamName={modifiedTeamName} />;
}

const Goals = () => (
  <GoalAnalyticsProvider>
    <TeamWithoutGoalAnalyticsProvider />
  </GoalAnalyticsProvider>
);
export default Goals;

export const TableAndFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${themeColors.neutral.EBEFF3};

  border-radius: 8px;
  padding: 16px;
`;
